import React from "react";

import ChatAvatar from "../ChatAvatar";
import SoftTypography from "../../SoftTypography";

const ListElement = ({
  image,
  name,
  latestMessage,
  selected,
  onSelected,
  setSelectedChat,
  isGroupChat = false,
  messageTime,
  unreadCount = 0,
}) => {
  let previewText = "No messages yet";
  if (latestMessage) {
    previewText = latestMessage.length > 50 ? `${latestMessage.substring(0, 35)}....` : latestMessage;
  }

  return (
    <div
      onClick={() => {
        onSelected();
        setSelectedChat();
      }}
      className={`flex items-start gap-3 px-3 py-2.5 rounded-xl cursor-pointer transition-colors ${
        selected ? "bg-blue-50" : "hover:bg-gray-50"
      }`}
    >
      <ChatAvatar name={name} image={image} isGroupChat={isGroupChat} size={40} />
      <div className="flex-1 min-w-0">
        <div className="flex items-center justify-between gap-2">
          <SoftTypography
            display="block"
            variant="h6"
            className="truncate"
            sx={{ fontSize: "14px", fontWeight: 700, color: "#1E293B" }}
          >
            {name}
          </SoftTypography>
          {messageTime && (
            <span className="flex-shrink-0 text-[11px] text-gray-400">
              {messageTime}
            </span>
          )}
        </div>
        <div className="flex items-center justify-between gap-2 mt-0.5">
          <SoftTypography
            display="block"
            variant="button"
            className="truncate"
            sx={{ fontSize: "13px", fontWeight: 400, color: "#64748B" }}
          >
            {previewText}
          </SoftTypography>
          {unreadCount > 0 && (
            <span className="flex-shrink-0 min-w-[20px] h-5 px-1 rounded-full bg-blue-600 text-white text-[11px] font-semibold flex items-center justify-center">
              {unreadCount > 9 ? "9+" : unreadCount}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default ListElement;
